import type { Release } from '../releases.ts';

export default {
  version: '0.93.2',
  date: '2026-10-08',
  title: 'PRISM Graphics: the released bridge',
  summary: [
    'PRISM talks to the graphics editor through PRISM Graphics’ own released bridge; the editor behaves as before',
    'If the editor does not answer Close within 15 seconds, PRISM asks whether to close it',
  ],
  features: [
    'PRISM Graphics: PRISM now talks to the editor with PRISM Graphics’ own bridge, @prism-graphics/bridge 1.0.0, vendored in the repository and installed with the app (no registry), instead of PRISM’s stand-in written from its documentation. The editor behaves as before: the same frame and sandbox, the same checks on every message, the dark theme, the unsaved-changes guard and the list refresh on save. If the editor does not answer Close within 15 s, PRISM asks whether to close it anyway',
  ],
  fixes: [],
} satisfies Release;
